import moment from "moment";

const getCurrentDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const initialFormData = {
  fullName: "",
  email: "",
  transaction_type: "",
  phoneNumber: "",
  addressLine1: "",
  city: "",
  addressLine2: "",
  state: "",
  postalCode: "",
  registrationNumber: "",
  industry: "",
  description: "",
  adminFullname: "",
  adminEmail: "",
  adminPhone: "",
  adminPassword: "",
  limit_group: "",
  comm_grp_id: "",
};

export const initialFormDataUser = {
  fullName: "",
  email: "",
  date_of_birth: "",
  phoneNumber: "",
  addressLine1: "",
  city: "",
  addressLine2: "",
  state: "",
  postalCode: "",
  description: "",
  supervisor_id: "",
  password: "",
  role_code: "",
  date_of_birth: "",
  gender_id: "",
};

export const initialErrors = {
  fullName: "",
  email: "",
  transaction_type: "",
  phoneNumber: "",
  addressLine1: "",
  city: "",
  addressLine2: "",
  stateError: "",
  state: "",
  registrationNumber: "",
  industry: "",
  description: "",
  adminFullname: "",
  adminEmail: "",
  adminPhone: "",
  password: "",
  phoneNumber: "",
  datofBirth: "",
  nationalID: "",
  gender: "",
  upiID: "",
  limit_group: "",
  quantity: "",
  transactionID: "",
  transactionIDTRC: "",
  remarksCrypto: "",
  buyRate: "",
  sellRate: "",
  minQty: "",
  maxQty: "",
  comm_grp_id: "",
  limit_group_id: "",
  utr_id: "",
  payin_partner: "",
  payout_partner: "",
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const fieldValidation = (
  fieldName,
  value,
  autoGeneratePassword = false
) => {
  value = String(value);

  if (!value.trim() || value == "undefined" || value == "null") {
    switch (fieldName) {
      case "remarksCrypto":
        return "Remarks is required";
      case "minQty":
        return "Min Quantity is required";
      case "maxQty":
        return "Max Quantity is required";
      case "buyRate":
        return "Buy Rate is required";
      case "sellRate":
        return "Sell Rate is required";
      case "email":
        return "Email is required";
      case "webhook_alert_email":
        return "Pending URL is required";
      case "fullName":
        return "Full Name is required";
      case "key_id":
        return "Key Id is required";
      case "key_secret":
        return "Secret is required";
      case "webhook_url":
        return "Url is required";
      case "webhook_alert_email_payout":
        return "Url is required";
      case "webhook_secret_payout":
        return "Url is required";
      case "webhook_url_payout":
        return "Url is required";
      case "webhook_secret":
        return "Failure URL is required";
      case "phoneNumber":
        return "Phone is required";
      case "transaction_type":
        return "Business Type is required";
      case "addressLine1":
        return "AddressLine1 is required";
      case "city":
        return "City is required";
      case "state":
        return "State is required";
      case "approvedQty":
        return "Approved Quantity is required";
      case "approvedRate":
        return "Approved Rate is required";
      case "postalCode":
        return "Postal Code is required";
      case "nationalID":
        return "National ID is required";
      case "dateOfBirth":
        return "DOB is required";
      case "gender":
        return "Gender is required";
      case "adminFullname":
        return "Admin Full Name is required";
      case "adminPhone":
        return "Admin Phone is required";
      case "upiID":
        return "UPI ID is required";
      case "admin":
        return "Please select the user.";
      case "advanced_search_key_ticket":
        return "Please select the value.";
      case "advanced_search_value_ticket":
        return "Please enter the value.";
      case "content":
        return "Please enter the value.";
      case "subject_name":
        return "Please enter the value.";
      case "category":
        return "Please select the value.";
      case "subject":
        return "Please select the value.";
      case "adminEmail":
        return "Admin Email is required";
      case "adminPassword":
        if (!autoGeneratePassword) {
          return "Admin Password is required";
        }
        break;
      case "password":
        return "Password is required";
      case "transactionID":
        return "Transaction Id is required";
      case "quantity":
        return "Quantity is required";
      case "current_password":
        return "Current password is required";
      case "new_password":
        return "New password is required";
      case "confirm_password":
        return "Confirm password is required";
      case "whitelabel_display_name":
        return "Display Name is required";
      case "whitelabel_tagline":
        return "Tagline is required";
      case "activate_in_hour":
        return "Value is required";
      case "txn_utr_id":
        return "UTR is required";
      case "amount":
        return "Amount is required";
      case "amountAgent":
        return "Amount is required";
      case "amountMerchant":
        return "Amount is required";
      case "amountDistributor":
        return "Amount is required";
      case "amountAgentWithdraw":
        return "Amount is required";
      case "amountMerchantWithdraw":
        return "Amount is required";
      case "limit_group":
        return "Limit Group is required";
      case "gender_id":
        return "Gender is required";
      case "supervisor_id":
        return "Supervisor is required";
      case "date_of_birth":
        return "DOB is required";
      case "role_code":
        return "Role is required";
      case "limit_group_id":
        return "Limit Group is required";
      case "comm_grp_id":
        return "Commission Group is required";
      case "payin_partner":
        return "Payin Partner is required";
      case "payout_partner":
        return "Payout Partner is required";
      case "toAgent":
        return "To is required";
      case "toMerchant":
        return "To is required";
      case "toDistributor":
        return "To is required";
      case "digit1":
        return "Digit1 is required";
      case "digit2":
        return "Digit2 is required";
      case "digit3":
        return "Digit3 is required";
      case "digit4":
        return "Digit4 is required";
      default:
        return "";
    }
  }

  // Email validation
  if (
    fieldName === "agent_email" ||
    fieldName === "email" ||
    fieldName === "adminEmail"
  ) {
    if (!validateEmail(value)) {
      return "Invalid email format";
    }
  }

  // Phone number validation
  if (
    fieldName === "phoneNumber" ||
    fieldName === "adminPhone" ||
    fieldName === "agent_mobile"
  ) {
    if (!/^\d{10}$/.test(value)) {
      return "Only numbers and phone number must be 10 digits long";
    }
  }

  // Postal code validation
  if (fieldName === "postalCode" && !/^\d{6}$/.test(value)) {
    return "Only numbers and postal code must be 6 digits long";
  }

  // Password validation
  if (fieldName === "adminPassword" && !isValidPassword(value)) {
    return "Password must be at least 6 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character";
  }

  if (
    fieldName === "new_password" &&
    !isValidPassword(value) &&
    !autoGeneratePassword
  ) {
    return "Password must be at least 6 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character";
  }

  // Adjusted amount validation
  if (fieldName === "adjusted_amount" && (value <= 300 || value > 50000)) {
    return "Adjusted amount cannot be less than 300 and more than 50,000";
  }

  // Activate in hour validation
  if (
    fieldName === "activate_in_hour" &&
    !/^(0?[1-9]|1[0-9]|2[0-4])$/.test(value)
  ) {
    return "Please enter valid value";
  }

  // Quantity, approvedQty, and rates validation
  if (
    ["quantity", "approvedQty", "approvedRate", "buyRate", "sellRate"].includes(
      fieldName
    )
  ) {
    const regex = /^(?:[1-9]\d*|0)?(?:\.\d+)?$/;
    if (!regex.test(value)) {
      return "Please enter a valid value";
    }
  }

  // Amount validation for multiple fields
  if (
    [
      "amountAgent",
      "amountMerchant",
      "amountAgentWithdraw",
      "amountMerchantWithdraw",
      "amountDistributor",
      "amount",
    ].includes(fieldName)
  ) {
    const regex = /^[1-9]\d*$/;
    if (!regex.test(value)) {
      return "Please enter a valid value";
    }
  }

  // URL validation
  if (
    [
      "webhook_url",
      "webhook_secret",
      "webhook_alert_email",
      "webhook_url_payout",
      "webhook_secret_payout",
      "webhook_alert_email_payout",
    ].includes(fieldName)
  ) {
    const regex =
      /^https?:\/\/([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/;
    if (!regex.test(value)) {
      return "Please enter a valid URL";
    }
  }

  // Order code validation
  if (fieldName === "order_code" || fieldName === "agent_code") {
    const regex = /^[a-zA-Z0-9]+$/;
    if (!regex.test(value)) {
      return "Please enter a valid order code or agent code";
    }
  }

  return "";
};

const isValidPassword = (password) => {
  // Password must be at least 6 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+}{"':;?/>.<,])(?=.*[^\s]).{6,}$/;
  return passwordRegex.test(password);
};

export const createMerchantData = (formData, autoGeneratePassword) => {
  const {
    fullName,
    email,
    phoneNumber,
    transaction_type,
    addressLine1,
    addressLine2,
    city,
    state,
    postalCode,
    registrationNumber,
    industry,
    description,
    adminFullname,
    adminEmail,
    adminPhone,
    adminPassword,
  } = formData;

  const merchantDetail = {
    merchant_name: fullName,
    email_address: email,
    phone_number: phoneNumber,
    business_type_id: transaction_type,
    commision_group: formData.comm_grp_id,
    limit_group_id: formData.limit_group,
  };

  const addressDetail = {
    address1: addressLine1,
    address2: addressLine2,
    city_id: city,
    state_id: state,
    zip: postalCode,
  };

  const businessDetail = {
    business_registration_number: registrationNumber,
    industry_type_id: industry,
    description: description,
  };

  const adminDetail = {
    full_name: adminFullname,
    email_address: adminEmail,
    mobile_number: adminPhone,
    auto_generate_password: autoGeneratePassword,
    password: autoGeneratePassword ? "" : adminPassword,
  };

  const bankingDetail = {
    payin_partner: formData.payin_partner,
    payout_partner: formData.payout_partner,
  };

  return {
    merchant_detail: merchantDetail,
    address_detail: addressDetail,
    business_detail: businessDetail,
    admin_detail: adminDetail,
    banking_partner: bankingDetail,
  };
};

export const createUserData = (formData, autoGeneratePassword) => {
  const inputDate = formData.date_of_birth;
  const parts = inputDate.split("-");
  const formattedDateOfBirth = `${parts[2]}-${parts[1]}-${parts[0]}`;

  const profile = {
    full_name: formData.fullName,
    email_address: formData.email,
    auto_generate_password: autoGeneratePassword,
    password: autoGeneratePassword ? "" : formData.password,
    mobile_number: formData.phoneNumber,
    date_of_birth: formattedDateOfBirth,
    gender_id: formData.gender_id,
    role_code: formData.role_code,
    supervisor_id: formData.supervisor_id,
  };
  const addressDetail = {
    address1: formData.addressLine1,
    address2: formData.addressLine2,
    city_id: formData.city,
    state_id: formData.state,
    zip: formData.postalCode,
  };
  return {
    profile_detail: profile,
    address_detail: addressDetail,
  };
};

export const transactionSerachFormData = {
  merchant_order_code: null,
  order_code: null,
  agent_email: null,
  agent_mobile: null,
  customer_id: null,
  agent_id: null,
  agent_code: null,
  payment_method: null,
  transaction_type: null,
  status: null,
  from_date: moment().format("YYYY-MM-DD"), // getCurrentDate(),
  to_date: moment().format("YYYY-MM-DD"), // getCurrentDate(),
  advanced_search_value: null,
  advanced_search_key: null,
  distributor_id: null,
  utr_id: "",
};

export const scrapperFormData = {
  agent_id: null,
  from_date: moment().format("YYYY-MM-DDTHH:mm"), // getCurrentDate(),
  to_date: moment().format("YYYY-MM-DDTHH:mm"), // getCurrentDate(),
  distributor_id: null,
  process_flag: null,
  utr_id: null,
  source_bank: null,
};
